import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { Country } from '../../interface/country.interface';

@Component({
  selector: 'app-customnumber',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SelectModule, InputTextModule],
  templateUrl: './customnumber.component.html',
  styleUrls: ['./customnumber.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomnumberComponent),
      multi: true,
    },
  ],
})
export class CustomnumberComponent implements ControlValueAccessor {
  @Input() label!: string;
  @Input() id!: string;

  value = '';
  disabled = false;

  countries: Country[] = [
    {
      name: 'Egypt',
      code: 'eg',
      dialCode: '+20',
      flagUrl: 'assets/flags/eg.png',
      placeholder: '0100 123 4567',
    },
    {
      name: 'Saudi Arabia',
      code: 'sa',
      dialCode: '+966',
      flagUrl: 'assets/flags/sa.png',
      placeholder: '05x xxx xxxx',
    },
    {
      name: 'United Arab Emirates',
      code: 'ae',
      dialCode: '+971',
      flagUrl: 'assets/flags/ae.png',
      placeholder: '050 xxx xxxx',
    },
    {
      name: 'United States',
      code: 'us',
      dialCode: '+1',
      flagUrl: 'assets/flags/us.png',
      placeholder: '(201) 555-0123',
    },
  ];

  selectedCountry = this.countries[0];

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input?.value ?? '';
    this.emitValue();
  }

  onCountryChange() {
    this.value = ''; // لما تتغير الدولة يتم مسح الرقم
    this.emitValue();
  }

  emitValue() {
    const phone = `${this.selectedCountry.dialCode} ${this.value}`.trim();
    this.onChange(phone);
  }

  onBlur(): void {
    this.onTouched();
  }
}
